<template>
  <div class="h-full w-full overflow-hidden text-14px flex flex-col">
    <div
      class="h-full w-full overflow-hidden text-14px  border-solid border-1px rounded-10px rounded-16px border-[#EBEBEB] px-10px flex flex-col "
    >
      <div>
        <ColumnHeader
          v-show="data.showTitle"
          :title="title"
          @loadMore="loadMore"
          :showMore="data.showMore && !specialSource.includes(data.dataSource)"
        />
      </div>
      <div ref="listRef">
        <div class="flex-1 overflow-y-auto auto_list">
          <div v-for="(it, index) in list" :key="index" @click="liClick(it)">
            <div
              class="w-full cursor-pointer py-10px border-b-2px border-dashed border-[#EBEBEB] box-content"
              @click="liClick(it)"
              :class="{
                '!border-0': index === list.length - 1,
              }"
            >
              <div class="flex items-center">
                <div
                  :title="it.title"
                  class="flex-1 text-15px !leading-18px word_style"
                  :style="{
                    '-webkit-line-clamp': row,
                    height: row * 18 + 'px',
                    color: it.titleStyle ? it.titleStyle.color : null,
                    fontWeight:
                      (it.titleStyle && it.titleStyle.fontWeight) || data.showContent
                        ? 'bold'
                        : null,
                  }"
                >
                  {{ it.title }}
                </div>
              </div>
              <div v-if="data.showContent" class="mt-4px text-14px !leading-17px">
                {{ it.summary }}
              </div>
              <div
                v-if="data.showDate"
                class="mt-8px text-12px leading-14px text-[#999999] flex items-center"
              >
                <span class="icon iconfont icon-line-unfinish mr-5px"></span>
                发布时间：{{ dayjs(it.editPublishTime).format('YYYY-MM-DD') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColumnTableSearchApi, ColumApi } from '@wiz-api/workbench'
import dayjs from 'dayjs'
import addRequestQueue from '@/assets/js/RequestQueue'
import ColumnHeader from './ColumnHeader'

const columnTableSearch = new ColumnTableSearchApi()
const columApi = new ColumApi()

export default {
  name: 'NewsTwo',
  components: { ColumnHeader },
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update', // update/view   update模式不触发点击
    },
    height: {
      type: String,
      default: 'fixed',
    },
    i: {
      type: String,
      default: '',
    },
    // data: {
    //   dataSource: '', 数据来源
    //   showContent: true, 显示摘要
    //   showDate: true, 显示时间
    //   showPagination: true, 显示分页
    //   showTitle: true, 显示栏目标题
    //   pageSize: 10, 展示条数
    // }
  },
  data() {
    return {
      list: [],
      title: '列表',
      dataSource: '',
      page: {
        pageNo: 1,
        pageSize: 1,
        totalCount: 0,
      },
      row: 1,
      col: 1,
      specialSource: [
        '11111111-1111-1111-1111-111111111111',
        '22222222-2222-2222-2222-222222222222',
      ],
    }
  },
  methods: {
    loadMore() {
      if (this.mode !== 'update') {
        this.$router.push({
          path: '/portal/homepage',
          query: {
            columnId: this.data.dataSource,
          },
        })
      }
    },
    liClick(item) {
      if (this.mode !== 'update') {
        if (item.externalLink) {
          window.open(item.externalLink)
        } else {
          this.$router.push({
            path: '/portal/ColumnDetail',
            query: {
              id: item.id,
              type: item.type,
            },
          })
        }
      }
    },
    async getListData() {
      let params = {}
      if (this.data.dataSource === '22222222-2222-2222-2222-222222222222') {
        params = {
          columnId: this.data.columnId,
          ignoreId: this.data.columnTableId,
        }
      } else {
        params = {
          columnId: this.data.dataSource,
        }
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableSearch.searchColumnTable(this.page.pageNo, this.page.pageSize, params)
      })
      if (!err) {
        this.list = _.map(res.items, (item) => {
          item.titleStyle = item.titleStyle ? JSON.parse(item.titleStyle) : null
          return item
        })
        this.page.totalCount = res.totalCount

        this.changeLayout()

        this.$emit('nextTick')
      }
    },
    changeLayout() {
      this.$nextTick(() => {
        const commonHeader = document.querySelector('#commonHeader')
        const height = this.$refs.listRef.offsetHeight + commonHeader.offsetHeight
        console.log('height', height)
        this.$emit('changeLayout', {
          height,
          i: this.i,
        })
      })
    },
    async getHotListData() {
      const [err, res] = await addRequestQueue(() => {
        return columnTableSearch.getHotColumnTable(this.page.pageNo, this.page.pageSize, {
          hotStartTime: dayjs()
            .subtract(7, 'days')
            .format('YYYY-MM-DD HH:mm:ss'),
          hotEndTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        })
      })
      if (!err) {
        this.list = _.map(res.items, (item) => {
          item.titleStyle = item.titleStyle ? JSON.parse(item.titleStyle) : null
          return item
        })
        this.page.totalCount = res.totalCount
        const height = this.$refs.listRef.offsetHeight
        this.$emit('changeLayout', {
          height,
          i: this.i,
        })
        this.$nextTick(() => {
          this.$emit('nextTick')
        })
      }
    },
    async getTitle() {
      if (this.data.title && this.data.dataSource) {
        this.getListData()
        return
      }
      if (this.data.dataSource !== '' && this.data.dataSource != null) {
        const [err, res] = await columApi.getColumnDetail(this.data.dataSource)
        if (!err) {
          this.title = res.name
          this.getListData()
        }
      }
    },
  },
  created() {},
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        if (!_.isEmpty(val)) {
          if (oldVal && oldVal !== val) {
            this.changeLayout()
          }
          this.row = val.row || 2
          this.col = val.col || 1
          if (val.title) this.title = val.title
          if (val.dataSource !== this.dataSource || this.col !== this.page.pageSize) {
            this.page.pageSize = this.col
            this.dataSource = val.dataSource
            switch (val.dataSource) {
              case '11111111-1111-1111-1111-111111111111':
                this.title = '本周热门排行'
                this.getHotListData()
                break
              case '22222222-2222-2222-2222-222222222222':
                this.title = '相关推荐'
                this.getListData()
                break
              default:
                this.getTitle()
                break
            }
          }
        }
      },
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.word_style {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.auto_list {
  &::-webkit-scrollbar {
    width: 1px !important;
    display: none !important;
  }
}
.clearfix {
  *zoom: 1;
  &::after {
    content: '';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
}
.simSun {
  font-family: 'SimSun';
}
</style>
